/* ==========================================================================
   SearcherFli > Client > Submit
   ========================================================================== */

/* Modules */
const Button = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/client/js');

const { buildUrl } = require('../utils/url');
const { validate, validateOpenjaw } = require('../utils/validation');
const { addLoader } = require('./loader');

const configuration = require('../config');
const { OPENJAW, ROUNDTRIP } = require('../product/constants');
const { buildFormBody } = require('../utils/cross-selling');

/* Has error */
function hasErrorForm(instance) {
    const { product } = instance.store.select('data');
    if (product === OPENJAW) return validateOpenjaw(instance);
    return validate(instance);
}

/* Init */
function initSubmit(instance) {
    const panel = instance;

    /* Selector */
    const { selector } = instance;

    /* Reference */
    panel.submit = Button(`${selector} [data-component='ButtonRxjs'][data-type='${configuration().type.submit}']`);

    /* Subscriptions */
    panel.subscriptions = {
        ...instance.subscriptions,
        submit: instance.submit.events.click$.subscribe(() => {
            if (!hasErrorForm(instance)) return;

            addLoader(instance);

            /* Save state */
            const stateInput = panel.element.querySelector(`input[name='${configuration().type.formState}']`);
            stateInput.value = JSON.stringify({
                data: instance.store.select('data'),
                openjaw: instance.store.select('openjaw'),
                crossSelling: instance.store.select('crossSelling')
            });

            /* Cross selling */
            const { includeHotels = false } = instance.store.select('crossSelling');
            const { product } = instance.store.select('data');

            if (includeHotels && product === ROUNDTRIP) {
                const { endpoints = {} } = instance.config;

                const params = buildFormBody(instance);
                window.location.assign(`${endpoints.crossSelling}?${params.toString()}`);
            } else {
                const url = buildUrl(instance);
                window.location.assign(url);
            }
        })
    };
}

/* Destroy */
function destroySubmit(instance) {
    const panel = instance;

    /* Reference */
    instance.submit.actions.destroy();
    delete panel.submit;
}

/* Exports */
module.exports = {
    initSubmit,
    destroySubmit
};
